import { getAccessToken } from 'common/utils/auth/accessToken';
import { EMPTY_STRING } from 'common/constants';

export const getAuthData = () => ({
  access_token: getAccessToken() ? `Bearer ${getAccessToken()}` : EMPTY_STRING,
});
